import React, { useContext, useEffect, useState } from "react";
import {
  FilterSearch,
  FilterSearchToggle,
} from "@/components/filter-search/filter-search";
import { Tooltip, Button } from "react-bootstrap";
import styles from "@/page-components/cost-explorer/components/filter-section/filter-section.module.css";
import TagItem from "../../filter-section/tag-item.part";
import { FilterContext } from "../../filter-section/filter-section.component";
import { useDimensionTagsKeys } from "@/services/costExplorer/getDimensionTags.repo";
import add from "@/assets/img/add.svg";

export default function FilterSectionUsage({ filterData, setRange }) {
  const filterContext = useContext(FilterContext);
  const selectedAccounts = filterContext?.selectedaccount || [];
  const [tempSelectedAccounts, setTempSelectedAccounts] = useState([]);
  const [currentSelectedAccounts, setCurrentSelectedAccounts] = useState([]);

  // Region states
  const selectedRegions = filterContext?.selectedregion || [];
  
  const [tempSelectedRegions, setTempSelectedRegions] = useState([]);
  const [currentSelectedRegions, setCurrentSelectedRegions] = useState([]);
  const [applyTrue, setApplyTrue] = useState(false);

  const { data: dimensionKeys } = useDimensionTagsKeys({
    service: filterContext.selectedCloud,
  });

  useEffect(() => {
    setTempSelectedAccounts(selectedAccounts);
    setCurrentSelectedAccounts(selectedAccounts);

    setTempSelectedRegions(selectedRegions);
    setCurrentSelectedRegions(selectedRegions);
  }, [selectedAccounts, selectedRegions]);

  // Account handlers
  const handleAccountApply = () => {
    filterContext?.setselectedaccount(tempSelectedAccounts);
    setCurrentSelectedAccounts(tempSelectedAccounts);
  };

  const handleAccountCancel = () => {
    setTempSelectedAccounts(currentSelectedAccounts);
  };

  // Region handlers
  const handleRegionApply = () => {
    filterContext?.setselectedregion(tempSelectedRegions);
    setCurrentSelectedRegions(tempSelectedRegions);
  };

  const handleRegionCancel = () => {
    setTempSelectedRegions(currentSelectedRegions);
  };

  return (
    <div
      className={styles.filter_main_div}
      style={{ padding: "16px 22px 16px 16px", width: "100%" }}
    >
      <div style={{ width: "100%", gap: 4 }}>
        <span className={styles.dimension_name_css}>
          {filterContext?.selectUsageDimension}
        </span>
        <FilterSearch
          options={(filterData?.services || []).map((e) => ({
            id: e.serviceId || null,
            name: e.serviceName || null,
          }))}
          displayValue="name"
          onSelect={(v) => {
            filterContext?.setselectedservice(v.id);
          }}
          selectedValues={[filterContext.selectedservice || ""]}
          toggle={
            <FilterSearchToggle placeholder={filterContext.selectedservice} />
          }
        />
      </div>

      {filterContext?.selectedDimension !== "account_name" &&
        filterContext?.selectedDimension !== "subscriptionName" &&
        filterContext?.selectedDimension !== "project_id" && (
          <div style={{ width: "100%" }}>
            <span className={styles.dimension_name_css}>
              {filterContext?.selectedCloud === "azure"
                ? "Subscription"
                : filterContext?.selectedCloud === "aws"
                ? "Account"
                : "Project"}
            </span>

            <FilterSearch
              multiselect
              showApply
              applyTrue={applyTrue}
            setApplyTrue={setApplyTrue}
              options={(filterData?.accounts || []).map((e) => ({
                id: e.accountId || null,
                account: e.accountName || null,
              }))}
              itemRenderer={(item) => {
                return <span>{item.account}</span>;
              }}
              displayValue="account"
              // onSelect={(v) => {
              //   filterContext?.setselectedaccount(v);
              // }}
              // onRemove={(v) => {
              //   filterContext?.setselectedaccount(v);
              // }}
              // selectedValues={filterContext.selectedaccount || []}
              selectedValues={tempSelectedAccounts || []}
              onSelect={(list) => setTempSelectedAccounts(list)}
              onRemove={(list) => setTempSelectedAccounts(list)}
              onApply={handleAccountApply}
              onCancel={handleAccountCancel}
              toggle={
                <FilterSearchToggle
                  placeholder={
                    filterContext?.selectedCloud === "azure"
                      ? "Subscription"
                      : filterContext?.selectedCloud === "aws"
                      ? "Account"
                      : "Project"
                  }
                />
              }
            />
          </div>
        )}
      {filterContext?.selectedDimension !== "region" &&
        filterContext?.selectedDimension !== "location" && (
          <div style={{ width: "100%" }}>
            <span className={styles.dimension_name_css}>Region</span>
            <FilterSearch
              multiselect
              showApply
              applyTrue={applyTrue}
            setApplyTrue={setApplyTrue}
              options={(filterData?.regions || []).map((e) => ({
                id: e.regionId || null,
                name: e.regionName || null,
              }))}
              displayValue="name"
              // onSelect={(v) => {
              //   filterContext?.setselectedregion(v);
              // }}
              // onRemove={(v) => {
              //   filterContext?.setselectedregion(v);
              // }}
              // selectedValues={filterContext.selectedregion || []}
              selectedValues={tempSelectedRegions || []}
              onSelect={(list) => setTempSelectedRegions(list)}
              onRemove={(list) => setTempSelectedRegions(list)}
              onApply={handleRegionApply}
              onCancel={handleRegionCancel}
              toggle={<FilterSearchToggle placeholder="Region" />}
            />
          </div>
        )}

      <hr class="w-100 mb-0 mt-0" />
      <div className={styles.filter_box_div}>
        <div className={styles.filter_name_padding}>
          <div className={styles.filter_name}>Tag</div>
          <Tooltip
            tooltipContent="Please select tags"
            overlayProps={{
              placement: "bottom-end",
            }}
          >
            {(_show, setShow) => {
              const disableBtn =
                filterContext.selectedFilters.length >= 1 &&
                filterContext.selectedFilters.some(
                  (e) => e.dimension.length === 0
                );
              return (
                <div
                  onMouseEnter={() => {
                    if (disableBtn) setShow(true);
                  }}
                  onMouseLeave={() => setShow(false)}
                >
                  <Button
                    disabled={disableBtn}
                    variant="link"
                    className="p-0"
                    onClick={() => {
                      filterContext.setSelectedTags((arr) => {
                        const newArr = [...arr];
                        newArr.push({
                          filterOn: "",
                          filterType: "include",
                          values: [],
                        });
                        return newArr;
                      });
                    }}
                  >
                    <img src={add} alt="" />
                  </Button>
                </div>
              );
            }}
          </Tooltip>
        </div>
        {/* <div className={styles.checkboxArea}>
          <input
            type="checkbox"
            style={{ width: "16px" }}
            checked={filterContext.untagged}
            onChange={(e) => {
              filterContext.setUntagged(e.currentTarget.checked);
            }}
          />
          <span>Show Untagged</span>
        </div> */}
        {/* <div className={styles.checkboxArea}>
          <input
            type="checkbox"
            style={{ width: "16px" }}
            checked={filterContext.untaggable}
            onChange={(e) => {
              filterContext.setShowUntaggable(e.currentTarget.checked);
            }}
          />
          <span>Show Untaggable Only</span>
        </div> */}
        {filterContext.selectedTags.map((tag, index) => (
          <TagItem
            service={filterContext.selectedCloud}
            tag={tag}
            index={index}
            tagItems={dimensionKeys || []}
          />
        ))}
      </div>
    </div>
  );
}
